/**
 * Language Codes
 */
export enum LanguageCode {
  /**
   * Portuguese
   */
  pt = 'pt',

  /**
   * Brazil
   */
  br = 'br',

  /**
   * English
   */
  en = 'en',

  /**
   * Spanish
   */
  es = 'es',

  /**
   * Galician
   */
  gl = 'gl',
}
